import { Box, Stack } from "@mui/material";
import { LifelinesView } from "../../../component/LifelinesView";
import { getLifelines, Lifeline } from "../../../../domain/model/Lifeline";
import { useTranslation } from "react-i18next";
import { CustomTextView } from "../../../component/CustomTextView";
import { COLOR_LIGHT_GRAY } from "../../../../data/colors/Colors";

export function ChooseLifelinesView({
  firstTeamName,
  secondTeamName,
  firstTeamLifelines,
  secondTeamLifelines,
  handleOnLifelinesClicked,
}: {
  firstTeamName: string;
  secondTeamName: string;
  firstTeamLifelines: Array<Lifeline>;
  secondTeamLifelines: Array<Lifeline>;
  handleOnLifelinesClicked: (
    lifelineId: string,
    isForFirstTeam: boolean
  ) => void;
}) {
  const { t } = useTranslation();
  return (
    <Stack
      spacing={2}
      width={"100%"}
      height={"100%"}
      sx={{ overflow: "auto" }}
      justifyContent={"space-between"}
      p={2}
    >
      <Stack spacing={0}>
        <CustomTextView
          text={t("choose_lifelines")}
          fontWeight="bold"
          variant="h6"
        />
        <CustomTextView
          text={t("double_tap_to_see_lifeline_details")}
          textColor={COLOR_LIGHT_GRAY}
          variant="body1"
        />
      </Stack>
      <Stack spacing={1}>
        <Stack spacing={1}>
          <CustomTextView
            text={`${t("team")} "${firstTeamName}" ${t("lifelines")} (${
              firstTeamLifelines.filter((l) => l.selected).length
            }/3)`}
            variant="body1"
          />
          <LifelinesView
            lifelines={firstTeamLifelines}
            onLifelineClicked={(id) => {
              handleOnLifelinesClicked(id, true);
            }}
          />
        </Stack>

        <Stack spacing={1}>
          <CustomTextView
            text={`${t("team")} "${secondTeamName}" ${t("lifelines")} (${
              secondTeamLifelines.filter((l) => l.selected).length
            }/3)`}
            variant="body1"
          />
          <LifelinesView
            lifelines={secondTeamLifelines}
            onLifelineClicked={(id) => {
              handleOnLifelinesClicked(id, false);
            }}
          />
        </Stack>
      </Stack>
    </Stack>
  );
}
